(function() {
    'use strict';

    angular
        .module('app.core')
        .factory('emitService', emitService);
    /*USE: emitService('order:created', {data});*/
    emitService.$inject = ['$rootScope'];
    /* @ngInject */
    function emitService($rootScope) {
        return function() { $rootScope.$emit.apply($rootScope, arguments); }
    }
})();


/*****************
 ** WEBPACK FOOTER
 ** ./app/core/emit.services.js
 ** module id = 152
 ** module chunks = 0
 **/